jQuery(document).ready(function(){

 // jQuery("html").attr( "data-scheme" , "light" ) ;
 
var swiper = new Swiper(".prodswipe", {
      spaceBetween: 10,
//loop: true,
     slidesPerView: 7,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".prodswipe1", {
      spaceBetween: 10,
loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  
});